// extracted by mini-css-extract-plugin
export default {"pAlert":"alert_pAlert__eZekN","pAlertsuccess":"alert_pAlertsuccess__McFEn","pAlerterror":"alert_pAlerterror__rbGtA","pAlertText":"alert_pAlertText__1RKP0"};